// extracted by mini-css-extract-plugin
module.exports = {"logosWrapper":"styles_logosWrapper__3gjBZ","logoWrapper":"styles_logoWrapper__2i2xB","logo":"styles_logo__30nU3","total":"styles_total__3Blpf"};